<template>
  <div :id="id"
       class="o-echarts">

  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
export default {
  name: 'NewSubjectChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'chart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      // id: '',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '(2020年6月4日)',
          left: 'right'
        },
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b} : {c} ({d}%)"
        // },
        tooltip: {
          trigger: 'item',
          formatter: function (params, ticket, callback) {
            // return params.name + "<br>" + params.percent + '%'
            return params.name + '<br>' + params.value.labelValue + '<br>' + '占比：' + params.percent + '%'
          }
        },
        dataset: [
          // {
          //   source: [
          //     { 'type': '非独立投保户数', 'labelValue': 60 },
          //     { 'type': '独立投保户数', 'labelValue': 30 }
          //   ]
          // },
          // {
          //   source: [
          //     { 'type': '非独立投保面积', 'labelValue': 40 },
          //     { 'type': '独立投保面积', 'labelValue': 30 }
          //   ]
          // }
        ],
        legend: {
          orient: 'vertical',
          right: 10,
          top: '30%',
          bottom: 20,
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'
          // data: ["非独立投保户数", "独立投保户数", "非独立投保面积", "独立投保面积"]
        },
        color: ['#1a8dee', '#48ebd0', '#73b4f8', '#13cdcc'],
        series: [
          {
          // name: "非独立独立投保户数",
            type: 'pie',
            radius: ['46%', '60%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
              //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            encode: {
              itemName: 'type',
              value: 'labelValue'
            },

            datasetIndex: 0
          // data: [
          //   {
          //     value: 185465,
          //     name: "非独立投保户数",
          //     itemStyle: {
          //       color: "#1a8dee"
          //     },
          //     tooltip: {
          //       formatter: "{a}</br>已完成：{c} ({d}%)"
          //     }
          //   },

          //   {
          //     value: 23000,
          //     name: "独立投保户数",
          //     itemStyle: {
          //       color: "#46f383"
          //     }
          //   }
          // ]
          },
          {
          // name: "非独立独立投保面积",
            type: 'pie',
            radius: ['27%', '42%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
              //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            datasetIndex: 1,
            encode: {
              itemName: 'type',
              value: 'labelValue'
            }
          // data: [
          //   {
          //     value: 182365,
          //     name: "非独立投保面积",
          //     itemStyle: {
          //       color: "#58bdf4"
          //     },
          //     tooltip: {
          //       formatter: "{a}</br>已完成{c} ({d}%)"
          //     }
          //   },

          //   {
          //     value: 25000,
          //     name: "独立投保面积",
          //     itemStyle: {
          //       color: "#48ebd0"
          //     }
          //   }
          // ]
          }
        ]

      }
    }
  },
  mounted () {
    // this.initMap()

  },
  watch: {

  },
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },
    initMap (optionData) {
      console.log('optionData:', optionData)
      // 设置时间
      this.option.title.subtext = optionData.date || ''
      // this.option.legend.data = optionData.legend
      // this.option.series = optionData.series
      this.option.dataset = optionData.dataset
      chart = echarts.init(
        document.getElementById(this.id)
      )
      chart.setOption(this.option)
      if (optionData.chartHeight) {
        chart.resize({height: optionData.chartHeight})
      } else {
        chart.resize({height: 300})
      }
    }

  },
  components: {

  }
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/NewSubjectChart.vue